import { GatewayConformite } from "@conformite/gateway";
import { useQuery } from "@tanstack/react-query";
import { GarantieFinanciereApi } from "../garantie-financiere.api";
import { garantieFinanciereKeys } from "../garantie-financiere.keys";

export function useGarantieFinanciereAdminQuery(
  siren: string | undefined,
  millesime: number | undefined,
  categorie: GatewayConformite.IasIobsp | undefined
) {
  return useQuery({
    queryKey: garantieFinanciereKeys.admin(
      siren ?? "",
      millesime ?? 0,
      categorie ?? ""
    ),
    queryFn: () =>
      GarantieFinanciereApi.getAdmin(siren!, millesime!, categorie!),
    enabled: Boolean(siren && millesime && categorie),
    staleTime: 30_000,
  });
}
